// #region Imports
import React = require('react');
import { IApplicationOptions, IWithApiOptionsProps } from './dataTypes';
// #endregion Imports

export { IApplicationOptions, IWithApiOptionsProps };

export type IFetcher = typeof window.fetch;

export const ApiContext = React.createContext<IApplicationOptions>({
    applicationRoot: '',
    apiBaseUrl: '',
    wrappedFetch: window.fetch,
});
